export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    // detect all client side errors
    // DEV TODO: report errors to error tracking software
    console.error('Error ==>', error, context);
  };
});
